import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { SetClusterData } from "../store/actions/sector-industry.actions";
import { AppState } from "../store/state/app.state";
import { SectorsAndIndustriesPageDataService } from "./sectors-and-industries-page-data-service";
import { GlobalHeader } from "../store/models/global-header.model";
import { SetMenuOption } from "../store/actions/global-header.actions";
import { AppService } from "../app.service";

@Injectable({
  providedIn: "root",
})
export class MegaMenuService {
  constructor(
    private store: Store<AppState>,
    private appService: AppService,
    private dataService: SectorsAndIndustriesPageDataService,
  ) {}
  setSelectedValues(data) {
    const obj: any = {
      allGeography: {},
      popularGeography: [],
      otherGeographies: [],
    };
    if (data.Error || data.error) {
      obj.error = true;
    } else if (
      (data.geographies && data.geographies.length === 0) ||
      (data.market_cap && data.market_cap.length === 0) ||
      (data.sub_groups && data.sub_groups.length === 0)
    ) {
      obj.error = true;
    } else {
      obj.error = false;
      obj.clusters = data.sub_groups;
      obj.marketCaps = data.market_cap;
      obj.selectedCompanyCount = data.selected_company_count;
      if (data.market_cap) {
        if (data.market_cap && data.market_cap[0]) {
          if (data.market_cap[0].children) {
            const selectedValues = data.market_cap[0].children
              .map((item) => (item.selected ? item.key : null))
              .filter((item) => !!item);
            obj.selectedMarketCaps = selectedValues;
          }
          if (data.market_cap[0].selected) {
            obj.selectedMarketCaps.push(data.market_cap[0].key);
          }
        }
      }
      if (data.sub_groups) {
        const selectedValue = data.sub_groups.find((item) => item.selected);
        if (selectedValue) {
          obj.selectedCluster = selectedValue.id;
        }
      }
      if (data.geographies && data.geographies.length) {
        obj.allGeography = data.geographies.filter(
          (item) => item.key === -1,
        )[0];
        // convert number type key to string because all other region and country ids will be string too
        obj.allGeography.key = obj.allGeography.key.toString();
        obj.popularGeography = data.geographies.filter(
          (item) => item.title === "Popular",
        )[0];
        obj.otherGeographies = data.geographies.filter(
          (item) => item.title !== "Popular" && Number(item.key) !== -1,
        ); // Except popular and all geographies
        obj.popularGeography.children.forEach((geo) => {
          geo.country_id = geo.country_id.map((id) => `C${id}`);
          geo.key = geo.country_id;
          geo.parent_region_ids = geo.parent_region_ids.map((id) => `R${id}`);
        });
        obj.otherGeographies.forEach((region) => {
          region.key = `R${region.region_id.toString()}`;
          // region.selected = true;
          region.children.forEach((country) => {
            country.key = `C${country.country_id.toString()}`;
          });
        });
        obj.otherSelected = {
          countries: new Set(),
          regions: new Set(),
        };
        obj.popularSelected = new Set();
        if (obj.allGeography.selected) {
          // obj.otherSelected.regions.add(obj.allGeography.key);

          obj.popularGeography &&
            obj.popularGeography.children &&
            obj.popularGeography.children.forEach(
              (item) => (item.selected = true),
            );

          const regions = obj.otherGeographies.map((region) => region.key);
          obj.otherSelected.regions = new Set(regions);
          obj.popularSelected = new Set(
            obj.popularGeography.children.flatMap((country) => country.key),
          );
        } else {
          obj.popularSelected = new Set(
            obj.popularGeography &&
              obj.popularGeography.children &&
              obj.popularGeography.children
                .filter((item) => item.selected)
                .map((item) => item.key)
                .flat(),
          );

          // obj.otherSelected.countries = new Set(obj.otherGeographies && (obj.otherGeographies as any).flatMap((region) => {
          //   return region.children.filter((item) => item.selected).map((item) => item.key);
          // }));
          // obj.otherSelected.regions = new Set(obj.otherGeographies && (obj.otherGeographies as any).flatMap((region) => {
          //   return region.filter((item) => item.selected).map((item) => item.key);
          // }).flat());

          const regions = new Set();
          const countries = new Set();
          obj.otherGeographies.forEach((region) => {
            // if (region.children.every((country) => country.selected)) {
            //   regions.add(region.key);
            // }
            if (region.selected) {
              regions.add(region.key);
            } else {
              region.children.forEach((country) => {
                if (country.selected) {
                  countries.add(country.key);
                }
              });
            }
          });
          obj.otherSelected.regions = regions;
          obj.otherSelected.countries = countries;
          // Sometimes UK, china and HongKong are displayed under popular category but they are not displayed under regions and countries
          // so they do not get marked as selected in otherSelected, so adding them explicitly.
          // Array.from(obj.popularSelected).forEach(countryId => obj.otherSelected.countries.add(countryId))
        }
      }
    }
    return obj;
  }

  loadFiltersAndUpdateStore(params) {
    return this.dataService
      .getCompaniesFilter(params)
      .subscribe((data: any) => {
        const obj = this.setSelectedValues(data);
        this.store.dispatch(
          new SetClusterData({
            error: obj.error,
            allGeography: obj.allGeography,
            popularGeography: obj.popularGeography,
            otherGeographies: obj.otherGeographies,
            popularSelected: obj.popularSelected,
            otherSelected: obj.otherSelected,
            marketCaps: obj.marketCaps,
            selectedMarketCaps: obj.selectedMarketCaps,
            clusters: obj.clusters,
            selectedCluster: obj.selectedCluster,
            selectedCompanyCount: obj.selectedCompanyCount,
            facetSelectionSettings: params,
          }),
        );
      });
  }

  checkAllGeographyStatus(selectedRegions, otherGeographies) {
    if (selectedRegions.length === 0) {
      return false;
    }
    const otherRegions = otherGeographies.map((region) => region.key);
    return otherRegions.every(
      (region) => selectedRegions.indexOf(region) !== -1,
    );
  }

  createUserSettingsForFilter(
    marketCaps,
    industryId,
    selectedGeographies,
    subGroups,
    otherGeographies,
  ) {
    const isAllGeographySelected = this.checkAllGeographyStatus(
      Array.from(selectedGeographies.regions),
      otherGeographies,
    );
    let geographyObj: {
      countries: Array<number>;
      regions: Array<number>;
    } = null;
    if (isAllGeographySelected) {
      geographyObj = {
        countries: [],
        regions: [-1],
      };
    } else {
      geographyObj = {
        countries: Array.from(selectedGeographies.countries).map((id: string) =>
          Number(id.replace("C", "")),
        ),
        regions: Array.from(selectedGeographies.regions).map((id: string) =>
          Number(id.replace("R", "")),
        ),
      };
    }
    return {
      market_cap: marketCaps,
      industry_id: industryId,
      subindustry_id: [subGroups],
      region_id: geographyObj.regions,
      country_id: geographyObj.countries,
    };
  }

  updateGlobalMenuLink(industryId) {
    let menuOption: any[] = [];
    const subscriber = this.store
      .select("globalHeader")
      .subscribe((data: GlobalHeader) => {
        menuOption = this.appService.deepClone(data.menuOption);
        if (menuOption) {
          const index = menuOption.findIndex(
            (option) => option.name === "Industry Analysis",
          );
          if (menuOption[index]) {
            menuOption[index].link = `/industry/${industryId}/kpis`;
          }
        }
      });
    subscriber.unsubscribe();
    this.store.dispatch(new SetMenuOption(menuOption));
  }
}
